<span class="payment-span" *ngIf="translateService.currentLang == 'en'"><span [innerHTML]="symbol"></span>{{price | number:'1.2-2':'en'}} {{currency}}</span>
<span class="payment-span" *ngIf="translateService.currentLang == 'fr'">{{price | number:'1.2-2':'fr'}} <span [innerHTML]="symbol"></span> {{currency}}</span>
